import React, { useContext, useEffect } from 'react'
import { Avatar, Checkbox, TableBody, TableCell } from '@material-ui/core'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import CustomDialog from '../../components/CustomDialog'
import Loader from '../../components/Loader'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import { itemsPerPage } from '../../shared/data'

import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
// import SalesReturnForm from '../../components/Forms/SalesReturn/SalesReturnForm'

import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'

import { formatDate, formatNumber, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useSalesReturn } from '../../hooks/Sales/useSalesReturn'
import { UserContext } from '../../context api/UserContext'
import { NoDataFound } from '../../components/NoDataFound'

export default function SalesReturn() {
  const [open, setOpen] = React.useState(false)
  const history = useHistory()
  const [detailDialog, setDetailDialog] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const handleDeleteOpen = () => setDeleteDialog(true)
  const handleDeleteClose = () => setDeleteDialog(false)
  const [editDialog, setEditDialog] = React.useState(false)
  const handleEditOpen = () => setEditDialog(true)
  const handleEditClose = () => {
    setEditDialog(false)
    setSalesReturn('')
  }
  const [openPopup, setOpenPopup] = React.useState(false)

  const [selected, setSelected] = React.useState([])
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)

  const [searchQuery, setSearchQuery] = React.useState('')
  const [file, setFile] = React.useState('')
  const { getAllSalesReturn, deleteSalesReturn, deleteManySalesReturn, BulkUpload, loading } = useSalesReturn()

  const { salesReturn } = useContext(FeatureContext)
  //console.log('SALES RETURN : ', salesReturn)
  const [page, setPage] = React.useState(1)
  const [category, setSalesReturn] = React.useState(1)
  const heading = [
    { label: 'Store', key: 'store' },
    { label: 'Store Code', key: 'storeCode' },
    { label: 'Purchase Invoice', key: 'purchaseInvoice' },
    { label: 'Sale Invoice', key: 'saleInvoice' },
    { label: 'Quantity', key: 'quantity' },
    { label: 'Purchase Invoice Date', key: 'purchaseInvoiceDate' },
    { label: 'Sales Invoice Date', key: 'saleInvoiceDate' },
    { label: 'Amount', key: 'amount' },
  ]

  let tempSalesReturn = []
  salesReturn &&
    salesReturn.forEach((item) =>
      tempSalesReturn.push({
        store: item.store && item.store.name,
        storeCode: item.store && item.store.storeCode,
        purchaseInvoice: item.sale && item.sale.invoiceNumber,
        saleInvoice: item.saleInvoiceNumber,
        quantity: item.quantity,
        purchaseInvoiceDate: formatDate(item.sale && item.sale.invoiceDate),
        saleInvoiceDate: formatDate(item.invoiceDate),
        amount: item.amount,
      })
    )

  const filteredSalesReturn =
    salesReturn &&
    salesReturn.filter(
      (category) => category
      // || category.description.toLowerCase().includes(searchQuery.toLowerCase())
    )

  const noOfPages = Math.ceil(salesReturn && salesReturn.length / itemsPerPage)

  const handleChange = (event, value) => {
    setPage(value)
  }
  useEffect(() => {
    // if (salesReturn) {
    getAllSalesReturn()
    // }
  }, [])

  const handleUploadFile = () => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('sheetName', 'salesReturn')
    BulkUpload(formData)
    setFile('')
  }
  const tempHeaders = [
    { label: 'salesReturnCode' },
    { label: 'storeCode' },
    { label: 'quantity' },
    { label: 'sku' },
    { label: 'amount' },
    { label: 'saleInvoiceNumber' },
    { label: 'invoiceDate' },
    { label: 'purchaseInvoiceNumber' },
  ]
  return (
    <Layout
      heading="Manage Sales Return"
      handleOpenDialog={handleOpen}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      headers={heading}
      data={tempSalesReturn ? tempSalesReturn : []}
      // setFile={setFile}
      bulkUpload={handleUploadFile}
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      openDialog={open}
      setOpenDialog={setOpen}
      // url={ROUTES.ADD_PRIMARY_SALES}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      // editUrl={`/edit-category/${selected.length && selected[0]._id}`}
      uploadedfile={file}
      setUploadedFile={setFile}
      tempHeaderData={[]}
      tempHeaders={tempHeaders}
      filename="sales_returns"
      sampleName="sample_sales_returns"
    >
      <CustomTable>
        <CustomTableHeading
          heading={[
            <Checkbox
              indeterminate={selected.length > 0 && selected.length < filteredSalesReturn.length}
              checked={filteredSalesReturn.length > 0 && selected.length === filteredSalesReturn.length}
              onClick={(event) => handleSelectAllClick(event, filteredSalesReturn, setSelected)}
            />,
            'return code',
            'Store',
            'Store Code',
            'Purchase invoice',
            'Sale Invoice',
            'quantity',
            'Purchase Invoice date',
            'Sale Invoice date',
            'Amount',
            'info',
          ]}
        />
        <TableBody>
          {!loading &&
            filteredSalesReturn.length > 0 &&
            filteredSalesReturn.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              const isItemSelected = isSelected(item, selected)

              return (
                <CustomTableRow key={index} onClick={() => setSalesReturn(item)}>
                  {/* <TableCell align="center">{<Avatar src={item.productImages[0]} />}</TableCell> */}

                  <TableCell align="center">
                    <Checkbox checked={isItemSelected} onClick={() => handleSelectedItem(item, selected, setSelected)} />
                  </TableCell>
                  <TableCell>{item.salesReturnCode}</TableCell>
                  <TableCell>{item.store && item.store.name}</TableCell>
                  <TableCell>{item.store && item.store.storeCode}</TableCell>
                  <TableCell>{item.sale && item.sale.invoiceNumber}</TableCell>
                  <TableCell>{item.saleInvoiceNumber}</TableCell>
                  <TableCell>{item.quantity}</TableCell>
                  <TableCell>{formatDate(item.sale && item.sale.invoiceDate)}</TableCell>
                  <TableCell>{formatDate(item.invoiceDate)}</TableCell>
                  <TableCell>{formatNumber(item.amount)}</TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle style={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => history.push(`/view-sales-return/${item._id}`)} />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && !filteredSalesReturn.length && <NoDataFound />}

      {/* DELETE CATEGORy */}
      <ConfirmDialog open={deleteDialog} handleClose={handleDeleteClose} name={category.categoryName} handleSubmit={() => deleteSalesReturn({ salesReturnId: category._id }, setSelected)} />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManySalesReturn({ salesReturnId: multipleId }, setSelected)}
      />

      {filteredSalesReturn.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
    </Layout>
  )
}
